/** All localStorage keys used for guest / logged-in cart snapshots. */
export const CART_STORAGE_KEYS = [
  "savedCartItems",
  "savedCartItems_sprint",
  "savedCartItems_relay",
  "phase2Cart",
];

export function clearCartStorage() {
  CART_STORAGE_KEYS.forEach((key) => {
    try {
      localStorage.removeItem(key);
    } catch (e) {
      // ignore quota / private mode errors
    }
  });
}
